import axios from 'axios';

interface ApiErrorResponse {
  message?: string | string[];
  error?: string;
}

export const formatApiErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError<ApiErrorResponse>(error)) {
    const responseMessage = error.response?.data?.message;
    if (Array.isArray(responseMessage) && responseMessage.length > 0) {
      return responseMessage.join('; ');
    }
    if (typeof responseMessage === 'string' && responseMessage.trim()) {
      return responseMessage;
    }
    if (typeof error.response?.data?.error === 'string' && error.response.data.error.trim()) {
      return error.response.data.error;
    }
    if (error.response?.status) {
      return `HTTP ${error.response.status}: ${error.message}`;
    }
  }

  return error instanceof Error ? error.message : 'Unknown error';
};
